<template>
  <div class="status-wrapper">
    <!-- Loading -->
    <div v-if="loading">
      <p>Verifying your payment...</p>
    </div>

    <!-- Success -->
    <div v-else-if="status === 'success'">
      <h2>
        ✅ MiME wallet recharge is successful. Your wallet balance will be updated within
        2–5 minutes.
      </h2>

      <p v-if="transactionId">Transaction ID: {{ transactionId }}</p>
      <p v-if="amount">Amount: {{ amount }} BDT</p>
    </div>

    <!-- Failed -->
    <div v-else>
      <h2>❌ {{ remarks || "Payment failed" }}</h2>
      <p>Please try again or contact support.</p>
    </div>

    <router-link to="/wallet/recharge">← Back to Recharge</router-link>
  </div>
</template>

<script>
import api from "@/services/api";

export default {
  name: "PaymentStatus",

  data() {
    return {
      loading: true,
      status: "",
      transactionId: "",
      amount: "",
      remarks: "",
    };
  },

  async created() {
    const paymentRefId = this.$route.query.payment_ref_id;
    const queryStatus = this.$route.query.status;

    // ===============================
    // 1. Validate Query Params
    // ===============================
    if (!paymentRefId || !queryStatus) {
      return this.setFailedState("Invalid payment information.");
    }

    // ===============================
    // 2. Verify Payment
    // ===============================
    try {
      const response = await api.post("/api/nagad_pw/callback/", {
        payment_id: paymentRefId, // ✅ updated key
      });

      const res = response?.data;

      if (res?.success && res?.data) {
        const payment = res.data;

        // ✅ Check actual payment status
        if (payment.status === "Success" && payment.statusCode === "000") {
          this.status = "success";
          this.transactionId = payment.orderId || "";
          this.amount = payment.amount || "";
        } else {
          this.setFailedState(payment.status || "Payment not successful");
        }
      } else {
        this.setFailedState(res?.message || queryStatus);
      }
    } catch (err) {
      const errorData = err?.response?.data || {};
      this.setFailedState(
        errorData?.message ||
          errorData?.error ||
          "Payment verification failed."
      );
    } finally {
      this.loading = false;
    }
  },

  methods: {
    setFailedState(message) {
      this.status = "failed";
      this.remarks = message;
      this.loading = false;
    },
  },
};
</script>

<style scoped>
.status-wrapper {
  padding: 40px;
  text-align: center;
  font-size: 22px;
}

.status-wrapper h2 {
  margin-bottom: 16px;
}

.status-wrapper a {
  display: inline-block;
  margin-top: 24px;
  font-size: 16px;
}
</style>